/*
  Ivy Pillow — hero-kaart: entrance-timeline, letterlijk overgenomen uit het
  aangeleverde component (timing en easing ongewijzigd). Extra: de kaart meet
  zijn eigen offset zodat hij precies tot de onderkant van het scherm reikt.
  Bij prefers-reduced-motion wordt de animatie volledig overgeslagen.
*/
(() => {
  function initIvyHeroKaart() {
    const gsap = window.gsap;
    const section = document.querySelector('.section-ivy-hero-kaart .hero');
    if (typeof gsap === 'undefined') {
      // Geen GSAP: de CSS-startstanden meteen loslaten zodat niets verborgen blijft
      if (section) section.classList.add('hero--klaar');
      return;
    }
    if (!section || section.dataset.ivyInit === 'true') return;
    section.dataset.ivyInit = 'true';

    // Kaarthoogte: viewport minus de afstand tot de kaart en de ondermarge
    const card = section.querySelector('.hero__card');
    const wrapper = section.closest('.section-ivy-hero-kaart');
    // svh in plaats van dvh: de hoogte verspringt dan niet wanneer de
    // adresbalk op mobiel in- en uitschuift tijdens het scrollen
    let laatsteBreedte = window.innerWidth;
    const zetHoogte = () => {
      if (!card || !wrapper) return;
      const boven = card.getBoundingClientRect().top + window.scrollY;
      const onder = parseFloat(getComputedStyle(wrapper).paddingBottom) || 24;
      document.documentElement.style.setProperty(
        '--ivy-hero-hoogte',
        `calc(100svh - ${Math.round(boven + onder)}px)`
      );
    };
    zetHoogte();
    window.addEventListener('resize', () => {
      // alleen herberekenen bij een echte breedtewijziging (rotatie/venster),
      // niet bij het hoogte-gepomp van de mobiele adresbalk
      if (window.innerWidth === laatsteBreedte) return;
      laatsteBreedte = window.innerWidth;
      zetHoogte();
    });

    const bg = section.querySelector('.hero__bg');
    const heading = section.querySelector('.hero__heading');
    const sub = section.querySelector('.hero__sub');
    const buttons = Array.from(section.querySelectorAll('.hero__btn'));
    const avatars = Array.from(section.querySelectorAll('.hero__avatar'));
    const proof = section.querySelector('.hero__social-tekst');

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      // Animatie overslaan — alles direct zichtbaar in ruststand
      gsap.set([bg, heading, sub, ...buttons, ...avatars, proof], {
        autoAlpha: 1,
        xPercent: 0,
        scale: 1,
        filter: 'none',
      });
      return;
    }

    // Startstanden — tekst en knoppen komen van rechts binnen
    gsap.set(bg, { scale: 1.05, filter: 'blur(8px)' });
    gsap.set([heading, sub, ...buttons, proof].filter(Boolean), { autoAlpha: 0, x: 60 });
    // Avatars schuiven van rechts in met blur die wegtrekt
    gsap.set(avatars, { autoAlpha: 0, xPercent: 300, filter: 'blur(20px)' });

    const tl = gsap.timeline({ delay: 0.05 });

    // Achtergrond: terugschalen + blur-clear verankert de hele reveal
    tl.to(bg, { scale: 1, filter: 'blur(0px)', duration: 1.2, ease: 'power2.out' }, 0)
      .to(heading, { autoAlpha: 1, x: 0, duration: 0.9, ease: 'power3.out' }, 0.15)
      .to(sub, { autoAlpha: 1, x: 0, duration: 0.85, ease: 'power3.out' }, 0.23)
      .to(buttons, { autoAlpha: 1, x: 0, duration: 0.8, ease: 'power3.out', stagger: 0.08 }, 0.31)
      .to(
        avatars,
        {
          autoAlpha: 1,
          xPercent: 0,
          filter: 'blur(0px)',
          duration: 0.85,
          ease: 'power3.out',
          stagger: 0.08,
        },
        0.39
      )
      .to(proof, { autoAlpha: 1, x: 0, duration: 0.8, ease: 'power3.out' }, 0.47);

    // Na de reveal de inline transforms van de knoppen strippen zodat de
    // CSS-hover met `scale` weer soepel kan animeren. De klasse hero--klaar
    // moet er eerst op: anders pakt de CSS-startstand (translateX(60px)) de
    // knoppen weer zodra hun inline transform verdwijnt.
    tl.call(() => {
      section.classList.add('hero--klaar');
      gsap.set(buttons, { clearProps: 'translate,rotate,scale,transform,x' });
    });
  }

  document.addEventListener('DOMContentLoaded', initIvyHeroKaart);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initIvyHeroKaart);
  }
})();
